import React from 'react';
import { SectionHeading } from './SectionHeading';
import { SectionCta } from './SectionCta';
import { FaqItem } from './FaqItem';
import { faqs } from '../data/content';
export function FaqSection() {
  return <section className="w-full bg-ink py-16 sm:py-24" aria-label="Frequently asked questions" data-id="element-128" data-mp="1blk8iuez4uyj">
      <div className="mx-auto max-w-3xl px-4 sm:px-6" data-id="element-129" data-mp="1gkn4lpcz7qud">
        <SectionHeading title={<>Frequently asked <span className="text-volt" data-id="element-131" data-mp="24a9288dp9y09">questions</span></>} data-id="element-130" data-mp="1glgbqrfukid1" />
        <div className="mt-10 border-t border-line" data-id="element-132" data-mp="28arwe932fg5m">
          {faqs.map(f => <FaqItem key={f.q} q={f.q} a={f.a} data-id="element-133" data-mp="28cvvmdq0rqzk" />)}
        </div>
        <SectionCta label="I’m ready — get instant access" data-id="element-134" data-mp="1uiv7edwp1mdg" />
      </div>
    </section>;
}